export const GLOBAL_STATE = 'CourseCampaign'

export const COURSE_CAMPAIGN = 'COURSE_CAMPAIGN' as const
export const COURSE_CAMPAIGN_CREATE = 'COURSE_CAMPAIGN_CREATE' as const
export const COURSE_CAMPAIGN_DELETE = 'COURSE_CAMPAIGN_DELETE' as const
export const COURSE_CAMPAIGN_LIST = 'COURSE_CAMPAIGN_LIST' as const
export const COURSE_CAMPAIGN_ALL = 'COURSE_CAMPAIGN_ALL' as const
